var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrayBokunLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "33px",
    viewBox: "0 0 90 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration/gray bokun logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 90 0 90 33 0 33"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration/gray-bokun-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6492021,25.0353134 L70.4721604,18.7658948 L75.4068646,22.7337025 L72.4972082,22.8175938 L70.3450758,25.0926252 L70.2919162,22.3134156 L59.6957168,25.0353134 L59.6492021,25.0353134 Z M27.2567442,14.8645356 L25.2341883,19.2459854 L24.5406219,18.5997735 L18.2138012,25.6017871 C18.2138012,25.6017871 18.1963582,24.6881198 18.1872214,24.3558772 C18.1872214,24.3068714 18.1431986,24.2877674 18.0692736,24.2877674 C17.6365214,24.2877674 16.1605124,24.9979361 16.1605124,24.9979361 L18.1232638,20.952882 L14.0598784,21.8175434 L19.1989147,17.836446 L21.0952166,19.7817267 L27.2567442,14.8645356 Z M29.9952932,20.0209414 L46.1890303,3.60317141 L53.1421373,12.7423358 C53.1421373,12.7423358 49.7681652,10.9390888 49.1327421,10.9390888 C49.0903805,10.9390888 49.058817,10.9473949 49.0430353,10.9656683 C48.7921885,11.2439215 42.8657259,18.5250189 42.8657259,18.5250189 L42.5326479,14.2224767 L41.3523391,16.6129625 L41.1853848,14.4600302 L29.9952932,20.0209414 Z M46.3360498,0 L46.3318967,0 L29.044235,17.4203121 L31.1049994,14.255701 L28.4038282,11.6667002 L21.9640435,17.0440473 L18.727954,16.0174176 L0,33 L90,33 L85.974823,30.0654669 L70.2744732,16.5 L59.1333881,23.0152781 L66.3639216,17.9826328 L46.3360498,0 Z",
    id: "Fill-1",
    fill: "#ADB5BD",
    mask: "url(#mask-2)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrayBokunLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gray-bokun-logo.64bb96d82c16f0ab9f61bc152477bd7e.svg";